<template>
    <div class='row no-gutters' style="padding:5px;">
        <div class='col-xs-12 form-group' :class="{ 'has-error': this.validation && this.validation.$error }">
            <!--<label class='control-label' v-if='label' :for='name'>{{ label }}</label>-->
            <div class="input-group password-input">
              <float-label :label="required ? label+'*': label">
                <input v-if="passwordNotVisible" autocomplete='off' type='password' :id='name' name='password*' ref='input' class='form-control' :placeholder="required ? label+'*': label" @input='updateValue($event.target.value)' @blur='blur' />
                <input v-else autocomplete='off' type='text' :id='name' :name='name' ref='input' class='form-control' :placeholder="required ? label+'*': label" @input='updateValue($event.target.value)' @blur='blur' />
              </float-label>
                <span class="input-group-addon" @click="showHidePassword">
                  <i class="glyphicon glyphicon-eye-close" v-if="passwordNotVisible"></i>
                  <i class="glyphicon glyphicon-eye-open" v-else></i>
                </span>
            </div>
            <div class='col-xs-12 help-block small' role='alert' v-if='validation && validation.$error'>
                <span v-if='requiredError'>The field is required</span>
                <span v-else-if='passwordError'>Password needs at least 8 characters. Must consist of at least one number character and one alphabet character</span>
                <span v-else-if='passwordMatchError'>The value entered does not match</span>
                <span v-else>Please enter a valid value for this field</span>
            </div>
        </div>
    </div>
</template>

<script>
// eslint-disable-next-line
import FloatLabel from 'vue-float-label/components/FloatLabel.vue';

export default {
  name: 'input-password',
  components: {
    FloatLabel,
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    validation: {
      type: Object,
      default() {
        return undefined;
      },
    },
  },
  computed: {
    required() {
      return (
        !this.loading &&
        this.validation &&
        (this.validation.required !== undefined ||
          !this.validation.requiredIf ||
            (this.value && this.validation.requiredIf !== undefined))
      );
    },
    requiredError() {
      return (
        this.validation &&
        this.validation.$error &&
        !this.validation.required && !this.validation.requiredIf
      );
    },
    passwordError() {
      return (
        this.validation &&
        this.validation.$error &&
        this.validation.password !== undefined && !this.validation.password
      );
    },
    passwordMatchError() {
      return (
        this.validation &&
        this.validation.$error &&
        this.validation.sameAsPassword !== undefined &&
          !this.validation.sameAsPassword
      );
    },
  },
  data: () => ({
    passwordNotVisible: true,
  }),
  methods: {
    blur() {
      // Only validate the input on blur
      if (this.validation) {
        this.validation.$touch();
      }
    },
    updateValue(value) {
      this.$emit('input', value);
    },
    showHidePassword() {
      this.passwordNotVisible = !this.passwordNotVisible;
    },
  },
  mounted() {
    if (this.validation && this.required) {
      this.$refs.input.required = true;
    }
  },
};
</script>
<style scoped>
.password-input {
  width: 98%;
  padding: 0 0 0 17px;
}
</style>



// WEBPACK FOOTER //
// InputPassword.vue?3413decf